<template>
<div class="cartView">
  <MainPreloader
      v-if="loading"
      position="fixed"
      :size="80"
      :stroke="3"
  />
  <StepView
      :step="steps"
      :active-index="0"
      :steps="steps"
  ></StepView>
  <CartPanel
      :items="cartItems"
      @reload="reloadHandler"
  ></CartPanel>
</div>
</template>

<script>
import {computed, onMounted} from "vue";
import CartPanel from "@/components/CartView/CartPanel.vue";
import {useCartStore} from "@/store/cart";
import StepView from "@/components/CartView/StepView.vue";
import {useCartTools} from "@/composables/cart-tools";
import MainPreloader from "@/components/shared/MainPreloader.vue";

export default {
  name: "CartView",
  components: {MainPreloader, StepView, CartPanel},
  setup() {
    const cartStore = useCartStore();
    const cartTools = useCartTools();
    const cartItems = computed(() => {
      return cartStore.items;
    });

    function reloadHandler() {
      cartStore.loadCart();
    }
    onMounted(() => {
      reloadHandler();
    });

    return {
      steps: cartTools.cartSteps,
      cartItems,
      reloadHandler,
      loading: cartStore.loading

    }
  }
}
</script>

<style scoped lang="scss"></style>
